/**
 *
 *  BookingBox
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 27/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useRef } from "react";
// import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Components
import Button from "../Button/Button";

// Icons
import CalendarIcon from "../../icons/CalendarTruBeIcon";
import CaretRightIcon from "../../icons/CaretRightIcon";
import ContactIcon from "../../icons/ContactIcon";

// Utils
import { isMobile } from "../../utils";

const Formsy = ({ children }) => {
  return <div>{children}</div>;
};

const BookingBox = ({
  timeSlotsActive,
  trainerFirstName,
  onTimeSlotsClick,
  onSubmit,
}) => {
  const bookingBoxRef = useRef();

  const isOnline = false;

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit && onSubmit();
  };

  return (
    <div className="booking-box" ref={bookingBoxRef}>
      <div className="booking-box-form-wrapper tbk-rounded-lg tbk-bg-basic-white tbk-p-2 tbk-shadow-trube lg:tbk-p-3">
        <Formsy
          name="BookingBoxForm"
          className="booking-box-form form-horizontal tbk-column-reverse lg:tbk-flex-column tbk-flex"
          onValidSubmit={handleSubmit}
          noValidate
        >
          <div className="">
            <div className="tbk-my-auto tbk-flex-grow tbk-rounded-lg">
              <Button
                className={`tbk-mb-2 tbk-hidden tbk-w-full lg:tbk-block ${
                  timeSlotsActive ? " active" : ""
                }`}
                color="green"
                startIcon={<CalendarIcon size={32} />}
                endIcon={<CaretRightIcon />}
                onClick={onTimeSlotsClick}
              >
                Availability
              </Button>
              <Button
                className={`tbk-mb-0 tbk-w-full`}
                color={isOnline ? "violet" : "coral"}
                disabled={!trainerFirstName}
                endIcon={<CaretRightIcon />}
                onClick={handleSubmit}
              >
                Book {trainerFirstName}
              </Button>
            </div>
          </div>
        </Formsy>
      </div>
      <div className="tbk-hidden lg:tbk-block">
        <div className="tbk-mt-3 tbk-mb-5 tbk-flex tbk-justify-center">
          <div className="tbk-text-main text-right tbk-text-grey">
            Have any questions?
          </div>
          <ContactIcon className="tbk-ml-1 tbk-mr-1" />

          {isMobile ? (
            <a
              href={"sms:+13233872101"}
              target="_blank"
              rel="noreferrer"
              className="tbk-text-main tbk-text-primary tbk-underline"
            >
              Speak to a Specialist
            </a>
          ) : (
            <Link
              to="/contact"
              target="_blank"
              className="tbk-text-main tbk-text-primary tbk-underline"
            >
              Speak to a Specialist
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

BookingBox.displayName = "BookingBox";

export default BookingBox;
